import React from 'react';

import ListItem from 'settings/page-elements/dropdown/ListItem';

export class ServiceItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.description,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.description !== this.state.description) {
      this.setState({ description: nextProps.description });
    }
  }

  onCheckboxClick = (name, id, value) => {
    this.props.onCheckboxClick(this.props.service.stylist_id, this.props.service.service_id, value);
  };

  render() {
    return (
      <ListItem
        itemName={this.props.service.name}
        description={this.state.description}
        id={`${this.props.service.stylist_id}x${this.props.service.service_id}`}
        checked={this.props.service.is_online}
        onCheckboxClick={this.onCheckboxClick}
        key={this.props.service.service_id}
        listName="Services"
        generalName={this.props.generalName}
      />
    );
  }
}

export default ServiceItem;
